import classNames from "classnames";
import { BG_COLORS } from "constant/app";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import Icon from "ui/icon";
import Header from "view/layout/header";

import Box from "vistar/ui/veneer/Box";
import Stack from "vistar/ui/veneer/Stack";
import Typography from "vistar/ui/veneer/Typography";

class Sidebar extends React.Component {
  static get propTypes() {
    return {
      activePath: PropTypes.string,
      children: PropTypes.node.isRequired,
      hideSettings: PropTypes.bool,
      user: PropTypes.object,
    };
  }

  render() {
    return (
      <aside className="main-sidebar">
        <section className="sidebar">
          <Header homepage="/overview" />
          <ul className="sidebar-menu">{this.props.children}</ul>
          <UserPanel
            user={this.props.user}
            hideSettings={this.props.hideSettings}
          />
        </section>
      </aside>
    );
  }
}

class Item extends React.Component {
  static get propTypes() {
    return {
      active: PropTypes.bool,
      badges: PropTypes.arrayOf(PropTypes.node),
      hide: PropTypes.bool,
      icon: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      rerenderView: PropTypes.bool,
      target: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      hide: false,
      rerenderView: false,
      target: "",
    };
  }

  render() {
    const { active, badges, hide, icon, label, link, rerenderView, target } =
      this.props;
    const iconClasses = classNames("fa", `fa-${icon}`);
    let linkElem;

    if (target === "_blank") {
      linkElem = (
        <a href={link} target="_blank" rel="noopener noreferrer">
          <i className={iconClasses} />
          <span>{label}</span>
          <small className="pull-right">{badges}</small>
        </a>
      );
    } else {
      const to = rerenderView
        ? {
            pathname: "/redirect",
            search: `to=${link}`,
          }
        : link;

      linkElem = (
        <Link to={to}>
          <i className={iconClasses} />
          <span>{label}</span>
          <small className="pull-right">{badges}</small>
        </Link>
      );
    }

    const liClasses = classNames({
      active,
      hide,
    });

    return <li className={liClasses}>{linkElem}</li>;
  }
}

class Badge extends React.Component {
  static get propTypes() {
    return {
      color: PropTypes.oneOf(BG_COLORS),
      text: PropTypes.string,
    };
  }

  render() {
    const { color, text, ...attrs } = this.props;
    const classes = classNames("label", `bg-${color}`);

    return (
      <span className={classes} {...attrs}>
        {text}
      </span>
    );
  }
}

class Tree extends React.Component {
  static get propTypes() {
    return {
      active: PropTypes.bool,
      children: PropTypes.node.isRequired,
      hide: PropTypes.bool,
      icon: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    };
  }

  static get defaultProps() {
    return {
      hide: false,
    };
  }

  render() {
    const classes = classNames({
      active: this.props.active,
      hide: this.props.hide,
      treeview: true,
    });

    const treeviewClasses = classNames({
      "treeview-menu": true,
      "menu-open": this.props.active,
    });

    return (
      <li className={classes}>
        <Link to={this.props.link}>
          <i className={classNames("fa", `fa-${this.props.icon}`)} />
          <span>{this.props.label}</span>
          <i className={classNames("fa", "fa-angle-down", "pull-right")} />
        </Link>
        <ul className={treeviewClasses}>{this.props.children}</ul>
      </li>
    );
  }
}

class UserPanel extends React.Component {
  static get propTypes() {
    return {
      hideSettings: PropTypes.bool,
      user: PropTypes.object,
    };
  }

  render() {
    const userName = this.props.user?.name || "";
    const accountName = this.props.user?.account?.name || "";

    return (
      <Box p={2}>
        <Stack direction="column" gap={1} mb={1} textAlign="center">
          <Typography color="white" variant="body2">
            Hello, {userName}
          </Typography>
          <Typography color="white" variant="body2">
            {accountName}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          {(!this.props.hideSettings && (
            <Link
              to="/settings"
              className={classNames("pull-left", "link-text")}
            >
              <Icon name="wrench" size="large" /> Settings
            </Link>
          )) || <Box />}
          <Link to="/logout" className={classNames("pull-right", "link-text")}>
            Logout <Icon name="sign-out" size="large" />
          </Link>
        </Stack>
      </Box>
    );
  }
}

export { Badge, Item, Sidebar, Tree };
